import React, {Component} from 'react'
import {connect} from 'react-redux';

import {bindActionCreators} from "redux";
import _ from 'lodash';


import Firebase from 'firebase/app'

import {FirebaseUtils, CricrushConfig, colors, CCButton, CCInput, strings, CCActions} from './../../cc-imports'

import PropTypes from 'prop-types'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";

class ReAuth extends Component {

    static propTypes = {
        onReAuthCompleted : PropTypes.func
    }

    static defaultProps = {
        onReAuthCompleted: ()=>{}
    }

    constructor(props) {
        super(props)
        this.initialState = {
            showSignIn: false,

            fbLoading: false,
            gglLoading: false,
            emailLoading: false,

            error: null,

            password: '',

            showGgl:false,
            showPwd:false,
            showFb: false
        }
        this.state = this.initialState;


        this._closeModal = this._closeModal.bind(this);
        this._showSignUp = this._showSignUp.bind(this);
        this._showSignIn = this._showSignIn.bind(this);

        this._toggleLoading = this._toggleLoading.bind(this);

        this._fbReAuth = this._fbReAuth.bind(this);
        this._gglReAuth = this._gglReAuth.bind(this);
        this._emailReAuth = this._emailReAuth.bind(this);
        this._reAuthCallback = this._reAuthCallback.bind(this);
        this._reAuthErr = this._reAuthErr.bind(this);
    }

    _closeModal() {
        this.setState({
            fbLoading: false,
            gglLoading: false,
            emailLoading: false,
            error: null,
        })
        this.props.actions.closeModal("ReAuth");
    }

    _showSignUp() {
        this.setState({showSignIn: false});
    }

    _showSignIn() {
        this.setState({showSignIn: true});
    }

    componentDidMount() {

        this._setupGoogleSignin();

        var providerData = Firebase.auth().currentUser.providerData;
        if(providerData){
            _.forEach(providerData, (data)=>{
                if(data.providerId == 'facebook.com'){
                    this.setState({showFb : true});
                }
                else if (data.providerId == 'google.com'){
                    this.setState({showGgl : true});
                }
                else if(data.providerId == 'password'){
                    this.setState({showPwd : true});
                }
            });
        }
    }

    _setupGoogleSignin() {
        /*GoogleSignin.hasPlayServices({
            //load prod configs
            autoResolve: true
        }).then(() => {
            GoogleSignin.configure(CricrushConfig.googleSigninConfig);
            const user = GoogleSignin.currentUserAsync();
        })
            .catch((err) => {
                //console.log(err)
            })*/
    }

    _toggleLoading(type, value) {
        switch (type) {
            case 'fb':
                this.setState({fbLoading: value});
                break;
            case 'ggl':
                this.setState({gglLoading: value});
                break;
            case 'email':
                this.setState({emailLoading: value});
                break;
            default:
                this.setState({fbLoading: value, gglLoading: value, emailLoading: value})
        }
    }

    _reAuthCallback(){
        /*var modal = _.find(this.props.modals.modals,(modal)=>{return modal.name=='ReAuth'})
        this.props.actions.closeModal('ReAuth');
        modal && modal.callback && modal.callback();*/
        this.props.onReAuthCompleted();
    }

    _reAuthErr(err){
        this.setState({error : FirebaseUtils.getFirebaseError(err)})
    }


    _fbReAuth() {
        this._toggleLoading('fb', true);
       /* LoginManager.logInWithReadPermissions(['public_profile', 'email', 'user_friends']).then(
            function (result) {
                if (result.isCancelled) {

                } else {
                    AccessToken.getCurrentAccessToken().then(
                        (data) => {
                            FirebaseUtils.reAuthFb(data.accessToken,this._reAuthCallback, this._reAuthErr);
                        }
                    )
                }
            }.bind(this),
            function (error) {
                this._toggleLoading('fb', false);
            }
        );*/
    }

    _gglReAuth() {
        this._toggleLoading('ggl', true);
        /*GoogleSignin.signIn()
            .then((user) => {
                FirebaseUtils.reAuthGgl(user.idToken,this._reAuthCallback, this._reAuthErr);
            })
            .catch((err) => {
                this._toggleLoading('ggl', false);
            })
            .done();*/
    }

    _emailReAuth() {
        this._toggleLoading('email', true);
        FirebaseUtils.reAuthEmail(this.props.user.user.email,this.state.password,this._reAuthCallback, this._reAuthErr);
    }


    render() {
        return (
            <CCErrorBoundary>
                    <div>
                        <div style={{width: '100%', alignItems: 'center', justifyContent: 'center'}}>

                            <div style={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: 20
                            }}>
                                <h1
                                      onClick={this._showSignUp}>{strings('reauth_modal_title')}</h1>
                            </div>

                            <div style={{width: '90%', marginTop: 15}}>
                                {
                                    this.state.showFb == true &&
                                    <CCButton type={"fb_reauth"} onPress={this._fbReAuth}
                                              loading={this.state.fbLoading}/>
                                }
                                {
                                    this.state.showGgl == true &&
                                    <CCButton type={"ggl_reauth"} style={{marginTop: 5}} onPress={this._gglReAuth}
                                              loading={this.state.gglLoading}/>
                                }
                            </div>
                            <div style={{
                                width: '90%',
                                marginTop: 15,
                                alignItems: 'center',
                                justifyContent: "center"
                            }}>
                            </div>
                            {
                                this.state.showPwd == true &&
                                <div style={{width: '90%', marginTop: 5, marginBottom: 20}}>
                                    <CCInput immediate={true} label={strings('password')} type={"password"} onEndEditing={(password) => {
                                        //console.log(password);
                                        this.setState({password})
                                    }}/>
                                    <CCButton title={strings('confirm')} style={{marginTop: 5}}
                                              onPress={this._emailReAuth} loading={this.state.emailLoading}/>
                                </div>
                            }
                        </div>

                        <div style={{width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                            <h1 style={{width: '80%',textAlign: 'center', color: colors.theme.txt_color4}}>{this.state.error}</h1>
                        </div>
                    </div>
            </CCErrorBoundary>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(ReAuth);


// WEBPACK FOOTER //
// ./src/app/screens/ReAuth/ReAuth.js